export default "__VITE_ASSET__64d2b517__"